module.exports = __webpack_public_path__ + "static/media/galeryBaseboards5.96a574cd.jpg";